export const OUTPUT_FILE_TOKEN = "{outputFile}";
